import tealium from '../../tealium';
import toDataLayerProduct, {
  formatProductData,
} from '../../tealium/data_layer/objects/product';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer, IProduct } from '../../../types';

/*const defaultData: IDataLayer = {
  event_name: 'product_detail_shade_size',
  enh_action: 'detail',
  event_category: 'ecommerce',
  event_action: 'spp',
  event_label: 'shade size switch',
};*/

// Temporary storage for transformed product
let productData: IProduct = {};

function trackSkuChange(_: string, eventData: IDataLayer = {}) {
  const { product, variant } = eventData.active_variant ?? {};

  if (product && variant) {
    productData = formatProductData(toDataLayerProduct(product, variant)) || {};

    const key = String(
      (productData.product_base_id as string[] | undefined)?.[0] ?? '',
    );

    if (key) {
      tealium.dataLayer.dataRegistries.productByProductId[key] = {
        ...productData,
      };
    }
    productData = {};
  }
  //tealium.evtLink({ ...defaultData, ...eventData });
}

// Export a function to get the stored data
export function getVariantSkuData(product_base_id: string | string[]) {
  const targetId = Array.isArray(product_base_id)
    ? String(product_base_id[0] ?? '').trim()
    : String(product_base_id).trim();

  return tealium.dataLayer.dataRegistries.productByProductId[targetId];
}

// Register the event handler
registerAnalyticsEventHandler('skuChange', trackSkuChange);
